import { z } from 'zod';

export const SCORING_PROMPT_DATA_MESSAGE = 'The household material is appended automatically. Remove {{input}} and <material>.';
export const CHAT_PROMPT_DATA_MESSAGE = 'The household context is appended automatically. Remove {{context}}, <scoring_snapshot> and <household_context>.';

const SCORING_DATA_MARKERS = /\{\{\s*input\s*\}\}|<\s*\/?\s*material\b/i;
const CHAT_DATA_MARKERS = /\{\{\s*context\s*\}\}|<\s*\/?\s*(?:scoring_snapshot|household_context)\b/i;

const PromptNotes = z.string().trim().min(3, 'Notes must be at least 3 characters').max(1000, 'Notes must be at most 1,000 characters');

export const CreatePromptVersionInput = z.object({
  template: z
    .string()
    .min(50, 'The template must be at least 50 characters')
    .max(50_000, 'The template must be at most 50,000 characters')
    .refine((t) => !SCORING_DATA_MARKERS.test(t), SCORING_PROMPT_DATA_MESSAGE),
  notes: PromptNotes,
  activate: z.boolean().default(true),
});
export type CreatePromptVersionInput = z.infer<typeof CreatePromptVersionInput>;

export const CreateChatPromptVersionInput = z.object({
  instructions: z
    .string()
    .min(50, 'The instructions must be at least 50 characters')
    .max(20_000, 'The instructions must be at most 20,000 characters')
    .refine((t) => !CHAT_DATA_MARKERS.test(t), CHAT_PROMPT_DATA_MESSAGE),
  notes: PromptNotes,
  activate: z.boolean().default(true),
});
export type CreateChatPromptVersionInput = z.infer<typeof CreateChatPromptVersionInput>;

export const PROMPT_UNCHANGED_MESSAGE = 'No changes from the active version';

const normalizePromptText = (text: string) => text.replace(/\r\n?/g, '\n').trim();

export function samePromptText(a: string, b: string): boolean {
  return normalizePromptText(a) === normalizePromptText(b);
}

export const PromptActivation = z.object({
  at: z.string(),
  byName: z.string(),
});
export type PromptActivation = z.infer<typeof PromptActivation>;

export const ChatPromptVersionDto = z.object({
  id: z.string().uuid(),
  version: z.string(),
  instructions: z.string(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  createdByName: z.string().nullable(),
  active: z.boolean(),
  activations: z.array(PromptActivation),
});
export type ChatPromptVersionDto = z.infer<typeof ChatPromptVersionDto>;

export const ChatLockedRules = z.object({ rules: z.string() });
export type ChatLockedRules = z.infer<typeof ChatLockedRules>;
